import { useEffect, useState } from "react";

// jsdom (unit tests) has no matchMedia; treat that as desktop.
const queryMatches = (query: string) =>
  typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia(query).matches;

/** True below Tailwind's `md` breakpoint; follows the viewport live (rotation, window resize). */
export const useIsMobile = (query = "(max-width: 767px)"): boolean => {
  const [matches, setMatches] = useState(() => queryMatches(query));

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
};
